
// const refreshData = (searchParams) => {
//   // fetch data

//   console.log(j360ListParams);

//   // const searchParams = new URLSearchParams(j360ListParams);

//   for (const key in j360ListParams) {
//     searchParams.set(key, j360ListParams[key]);
//   }

//   searchParams.set('j360_component', 'restaurant-list-row');

//   console.log(searchParams.toString());

//   fetch(`http://localhost:8360/wp-json/j360/v1/test?${searchParams.toString()}`)
//   .then((res) => res.text())
//   .then((data) => {
//     console.log(data);
//     document.getElementById('restaurant-list-id').innerHTML = data;
//   });
// }

// function j360FilterChanged (key, value) {
//   const url = new URL(window.location.href);
//   if (value) {
//     url.searchParams.set(`filter_${key}`, value);
//   } else {
//     url.searchParams.delete(`filter_${key}`);
//   }
//   url.searchParams.delete('jpage');
//   // navigate to new url
//   // window.history.pushState('', '', url.toString());
//   // window.history.replaceState('', '' , url.toString());
//   window.location.replace(url.toString());
//   // refreshData(url.searchParams);
// }

// function j360SortChanged (type, key, direction) {
//   j360ListParams['sort'] = `${type}/${key}/${direction}`;
//   refreshData();
// }

// window.j360FilterChanged = j360FilterChanged;
// window.j360SortChanged = j360SortChanged;